export const StatsEnum = {
  totalOrder: 1,
  totalRefAffiliate: 2,
};
